module.exports = {
      id: "arrow-blue-usage",
      viewBox: "0 0 15 17",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#arrow-blue",
      toString: function () {
        return this.url;
      }
    }